import React from 'react';
import { Briefcase } from 'lucide-react';

/**
 * Confirmation modal for switching between cases in AI Workspace
 */
const CaseSwitchConfirmModal = ({
  isOpen,
  pendingCase,
  onConfirm,
  onCancel
}) => {
  if (!isOpen || !pendingCase) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
            <Briefcase className="w-6 h-6 text-amber-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              Bytt sak?
            </h3>
            <p className="text-sm text-gray-600">
              Du bytter nå til <span className="font-semibold text-gray-900">{pendingCase.title || pendingCase.topic}</span>. Nye meldinger lagres på denne saken.
            </p>
          </div>
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
          >
            Avbryt
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
          >
            Bytt sak
          </button>
        </div>
      </div>
    </div>
  );
};

export default CaseSwitchConfirmModal;
